import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import QuantidadeMOTStore from "../stores/QuantidadeMOTStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomBarChart} from "../../comum/components/CustomBarChart";

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'DEPARTAMENTO', 'EMPRESA', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM', 'PRODUTO', 'AR_DEBITO'];

@inject("store")
@DataWrapper
@observer
export class VisaoGeralSolicitacoes extends Component {
    constructor(props) {
        super(props);
        this.controller = new QuantidadeMOTStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Visão geral das solicitações");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart dataKeys={["Quantidade"]} data={this.controller.dados}
                                        legend={false} labelAxisX={"Situação"} labelAxisY={"Quantidade"} />
                            </Col>
                        </Row>
                        {this.controller.dados &&
                        <Row>
                            <Col>
                                <p><b>Solicitadas: </b>Soma das quantidades de MOTs de todas solicitações, que não estejam em rascunho e cuja data de solicitação esteja contida no período definido no filtro.</p>
                                <p><b>Solicitadas exceção: </b>Soma das quantidades de MOTs de todas solicitações de exceção, que não estejam em rascunho e cuja data de envio esteja contida no período definido no filtro.</p>
                                <p><b>Contratadas: </b>Soma das quantidades de contratos que possuem data de início de trabalho da MOT dentro do período definido no filtro.</p>
                                <p><b>Canceladas: </b>Soma das quantidades de MOTs de todas solicitações em que a data da reprovação ou cancelamento esteja contida no período definido no filtro.</p>
                                <p><b>Em andamento: </b>Soma das quantidades de contratos em que a MOT possui pelo menos 1 dia trabalhado dentro do período definido no filtro.</p>
                                <p><b>Prorrogadas: </b>Soma das quantidades de contratos com prorrogação aprovada cuja data de início da prorrogação esteja contida no período definido no filtro.</p>
                                <p><b>Migradas: </b>Soma das quantidades de contratos com data de início de trabalho da MOT em um novo projeto/centro de resultado/finalidade (alterado) contido no período definido no filtro.</p>
                                <p><b>Substituídas: </b>Soma das quantidades de contratos com substituição de MOTs aprovada cuja data de início da substituição esteja contida no período definido no filtro.</p>
                                <p><b>Encerradas: </b>Soma das quantidades de contratos que a data de término esteja contida no período definido no filtro e não tiveram uma solicitação de término antecipado aprovada.</p>
                                <p><b>Encerradas (término antecipado): </b>Soma das quantidades de contratos que a data de termino esteja contida no período definido no filtro e tiveram uma solicitação de término antecipado aprovada.</p>
                            </Col>
                        </Row>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
